import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { coreSonarObjectsIdMapReducers } from './_idMap';
import { coreSonarObjectsOptimisticReducers } from './optimistic';

import { coreSonarObjectsApplicationsReducers, coreSonarObjectsApplicationsWatchers } from './applications';
import { coreSonarObjectsBulkReducers, coreSonarObjectsBulkWatchers } from './bulk';
import { coreSonarObjectsContextReducers, coreSonarObjectsContextWatchers } from './context';
import { coreSonarObjectsInitiativesReducers, coreSonarObjectsInitiativesWatchers } from './initiatives';
import { coreSonarObjectsPageLayoutsReducers, coreSonarObjectsPageLayoutsWatchers } from './pageLayouts';
import { coreSonarObjectsProfilesReducers, coreSonarObjectsProfilesWatchers } from './profiles';
import {
	coreSonarObjectsSalesforceUpdateableReducers,
	coreSonarObjectsSalesforceUpdateableWatchers
} from './salesforce';
import { coreSonarObjectsSearchReducers, coreSonarObjectsSearchWatchers } from './search';
import { coreSonarObjectsStakeholdersReducers, coreSonarObjectsStakeholdersWatchers } from './stakeholders';
import { coreSonarObjectsUsersReducers, coreSonarObjectsUsersWatchers } from './users';

export const coreSonarObjectsReducers = combineReducers({
	applications: coreSonarObjectsApplicationsReducers,
	bulk: coreSonarObjectsBulkReducers,
	byIdMap: coreSonarObjectsIdMapReducers,
	context: coreSonarObjectsContextReducers,
	initiatives: coreSonarObjectsInitiativesReducers,
	optimistic: coreSonarObjectsOptimisticReducers,
	pageLayouts: coreSonarObjectsPageLayoutsReducers,
	profiles: coreSonarObjectsProfilesReducers,
	salesforce: coreSonarObjectsSalesforceUpdateableReducers,
	search: coreSonarObjectsSearchReducers,
	stakeholders: coreSonarObjectsStakeholdersReducers,
	users: coreSonarObjectsUsersReducers
});

export const coreSonarObjectsWatchers = combineAllWatchers([
	coreSonarObjectsApplicationsWatchers,
	coreSonarObjectsBulkWatchers,
	coreSonarObjectsContextWatchers,
	coreSonarObjectsInitiativesWatchers,
	coreSonarObjectsPageLayoutsWatchers,
	coreSonarObjectsProfilesWatchers,
	coreSonarObjectsSalesforceUpdateableWatchers,
	coreSonarObjectsSearchWatchers,
	coreSonarObjectsStakeholdersWatchers,
	coreSonarObjectsUsersWatchers
]);
